<template>
    <v-form>
        <v-card>
            <v-toolbar dark color="primary">
                <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                <slot name="header"></slot>
            </v-toolbar>
            <v-card-text>
                <v-container grid-list-md>
                    <v-layout wrap>
                        <v-flex xs6>
                            <v-text-field
                                v-model="value.description"
                                v-validate="'required'"
                                :rules="[rules.numeric]"
                                :error-messages="errors.first('size')"
                                label="Size"
                                name="size"
                                required
                                maxlength="6"
                                suffix="m³"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                            <v-text-field
                                v-model="value.sortOrder"
                                v-validate="'required'"
                                :rules="[rules.sorter]"
                                :error-messages="errors.first('sort order')"
                                label="Sort Order"
                                name="sort order"
                                maxlength="4"
                                required
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <slot name="actions"></slot>
                <v-btn
                    color="primary"
                    @click="submit"
                >{{ !this.editing ? 'Save Changes' : 'Update' }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>

<script>
  import {VclList} from 'vue-content-loading';
  import FormValidation from '../FormValidation.vue';

  export default {
    props: {
      value: {
        required: true,
      },
    },
    components: {
      VclList,
    },
    mixins: [
      FormValidation,
    ],
    computed: {
      formTitle() {
        return !this.editing ? 'Add Container Size' : 'Edit Container Size';
      },
      editing() {
        return !!this.value.id;
      },
    },
    data() {
      return {
        submitted: false,
        rules: {
          numeric: value => {
            const pattern = /^\d+(\.\d{1,2})?$/;
            return pattern.test(value) || 'The size field must be a number';
          },
          sorter: value => {
            const pattern = /^([0-9]{1,4})$/;
            return pattern.test(value) || 'The sort order field must be an integer';
          }
        }
      };
    },
    methods: {
      submitForm() {
        if (!this.editing) {
          this.$emit('add', {id: this.id, model: this.value});
        } else {
          this.$emit('edit', {id: this.value.id, model: this.value});
        }
      },
    },
    watch: {
      value(val) {
        if (val.id) {
          this.id = val.id;
          this.value.description = this.value.description.substr(0, this.value.description.lastIndexOf('m³'));
        } else {
          this.id = this.$uuid.v1();
        }
      },
    },
  };
</script>
